import React,{useState,}from 'react'
import { Modal, } from 'antd';
import FundDesc from './FundDesc';
function FundCheck(props) {
    const [open,setOpen] = useState();
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                {props.titleType==='数字' ? props.ecal_id : '查看'}
            </a>
            <Modal                 
                open={open} 
                onOk={() => {setOpen(true)}} 
                onCancel={() => {setOpen(false)}} 
                okText='关闭' 
                width={1280}
                footer={null}
            >
                <FundDesc 
                    ecal_id={props.ecal_id}
                />       
            </Modal>
        </>
    )
}

export default FundCheck